import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../../../theme/style-helpers';
import DeleteIcon from '../../../../../assets/icons/trash_icon_gray.svg';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
`;

export const Overlay = styled.div`
    ${MediaQuery.xSmall(css`
    top: 40; bottom: 0 ;
    right: 0; left: 0;
    height: 100%;
    background-color:  rgba(0, 0, 0, 0.8);
    position: absolute;
    backdrop-filter: blur(2px);
    padding: 15px;
    overflow-y: scroll;
    z-index: 1;
    `)};
    ${MediaQuery.xLarge(css`
    display: unset;
    `)}
`;

export const ItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px;
    align-items: center;
    background-color: #F2F2F2;
    border-radius: 4px 4px 0px 0px;
    ${MediaQuery.medium(css`
       padding: 20px 32px;
    `)}; 
`;

export const ItemBody = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
    padding: 32px 20px;
    background-color: #F9F9F9;

    ${MediaQuery.medium(css`
       column-gap: 24px;
       grid-template-columns: max-content auto;
       padding: 32px;
       row-gap: 40px;
    `)};
    ${MediaQuery.xLarge(css`
        grid-template-columns: min-content auto max-content;
    `)};
`;

export const FieldsRow1 = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;

    ${MediaQuery.medium(css`
       grid-auto-flow: column;
       column-gap: 24px;
       grid-template-columns: 1fr 1fr;
       grid-column: 1 / -1;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(2, 1fr);
        grid-column: 1 / -2;
    `)};

`;

export const FieldsRow2 = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 32px;

    ${MediaQuery.medium(css`
       grid-auto-flow: column;
       column-gap: 24px;
       grid-template-columns: repeat(2, 126px);
       grid-row: 2;
       grid-column: 1;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(2, 126px);
        grid-row: unset;
        grid-column: unset;
    `)};
`;

export const FieldsRow3 = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
    grid-row: 2;

    ${MediaQuery.medium(css`
       grid-auto-flow: column;
       column-gap: 24px;
       grid-template-columns: auto 132px;
       align-items: end;
       grid-row: unset;
       grid-column: 2;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(2, 200px);
        grid-column: unset;
    `)};
`;

export const ItemTitle = styled.h3`
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const DeleteItemButton = styled.button`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
    margin: 0;
    padding-left: 22px;
    border: none;
    background-color: transparent;
    background-image: url(${DeleteIcon});
    background-position: left;
    background-repeat: no-repeat;
    cursor: pointer;
`;

export const MeasurementsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 32px;

    ${MediaQuery.medium(css`
       grid-auto-flow: column;
       column-gap: 24px;
       grid-template-columns: repeat(4, 126px);
       grid-column: 1 / -1;

    `)};

    ${MediaQuery.xLarge(css`
        grid-column: 2 / -1;
    `)};
`;

export const DangerousGoodsContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px; 

    ${MediaQuery.medium(css`
        grid-column: 1 / -1;
    `)};
`;

export const DangerousGoodsCheckboxContainer = styled.div`

    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px; 

    > p {
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: ${colors.BLACK};
        margin: 0;
    } 

    ${MediaQuery.medium(css`
        grid-column: 1 / -1;
        display: flex;
        justify-content:space-between;
        align-content: center;
        flex-direction: row-reverse;
    `)};
`;

export const DangerousGoodsCheckboxGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
`;

export const DangerousGoodsFields = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
    ${MediaQuery.medium(css`
        grid-template-columns: repeat(2, 280px);
        column-gap: 24px;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(3, 274px) 180px;
    `)};
`;

export const DangerousGoodsQuantityFields = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;     
`;
